import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MenuItem } from 'src/app/shared/models/menu-item';
import { smoothDropingDown } from '../../../animations/animations';

@Component({
    selector: 'app-menu',
    templateUrl: './app-menu.component.html',
    styleUrls: ['./app-menu.component.scss'],
    animations: [smoothDropingDown],
    standalone: true
})
export class AppMenuComponent implements OnInit {

  @Input() menuItems: Array<MenuItem>;
  @Output() onItemClick = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  public onMenuItemClicked(menuItem: MenuItem) {
    menuItem.action();
    this.onItemClick.emit();
  }
}
